// Generated: available widths and intrinsic size of /assets/images/cpr derivatives.
const images = {
    'arabkir-facade': {widths: [640, 1280, 1920], width: 1920, height: 1082},
    'baghramyan-front': {widths: [640, 1280, 1920], width: 1920, height: 1080},
    'baghramyan-portico': {widths: [640, 1280, 1920], width: 1920, height: 1477},
    'baghramyan-street': {widths: [640, 1280, 1920], width: 1920, height: 1477},
    'corridor': {widths: [640], width: 640, height: 853},
    'courtyard-lounge': {widths: [640, 1280, 1920], width: 1920, height: 1080},
    'courtyard-pavilion': {widths: [640, 1280, 1920], width: 1920, height: 1080},
    'courtyard-pool': {widths: [640, 1280, 1920], width: 1920, height: 1080},
    'elevator-hall': {widths: [640], width: 640, height: 853},
    'lobby': {widths: [640], width: 576, height: 768},
    'map': {widths: [640, 1280, 1920], width: 1920, height: 1419},
    'parking': {widths: [640], width: 640, height: 960},
    'terrace': {widths: [640, 1280, 1920], width: 1920, height: 1080},
};

export default images;
